// extracted by mini-css-extract-plugin
export default {"container":"style_container__eFWrP","logoBox":"style_logoBox__eoBN2","browserInstruction":"style_browserInstruction__5JAYh","text":"style_text__0gM7n","logo":"style_logo__2+yf+"};